export const All:number = -1